import styled from "styled-components";
import { device } from "./banner_responsives";

export const Wrapper = styled.div`
  width: 100vw;
  height: 75px;
  text-align: center;
  -webkit-box-shadow: 0 5px 2px -3px #BCBCBC;

  @media ${device.ipadPro}{
    margin: 0px;
    height: 40px;
  }


  @media ${device.mobileL}{
    padding-left: 0px;
    margin-left: 0px;
    min-height: 150px;
  }

`;

export const ElementsContainer = styled.div`
    width: 70%;
    display: flex;
    justify-content: space-between;
    position: relative;
    top: 25%;
    vertical-align: middle;
    margin: 0 auto;

  @media ${device.ipadPro}{
    width: 90vw;
    height: 40px;
    position: relative;
    top: 5%;
    left: 0%;
  }

  @media ${device.mobileL}{
    width: 80vw;
    height: 150px;
    position: relative;
    left: 12%;
    display: table-cell;
    vertical-align: middle;
  }

`;

export const MegagonLogo = styled.img`
  height: 45px;
  width: auto;
  display: inline-block;

 @media ${device.ipadPro}{
    height: 30px;
    left: 2%;
  }

  @media ${device.mobileL}{
    display: block;
    height: 40px;
    position: relative;
    left: 10%;
  }
`;

export const Title = styled.div`
  display: block;
  width: auto;
  /* height: 45px; */
  font-family: Poppins;
  font-weight: bold;
  font-size: 24px;
  color: #201F1F;
  letter-spacing: 1px;
  position: absolute;
  right: 40%;
  top: 15%;


  @media ${device.ipadPro}{
    top: 5%;
    font-size: 18px;
    right: 40%;
  }

  @media ${device.mobileL}{
    display: block;
    position: relative;
    right: 0%;
    font-size: 14px;
    letter-spacing: .9px;
    text-align: center;
    font-weight: bold;
  }

  `;



export const LinkContainer = styled.div`
  display: inline-block;
  text-transform: uppercase;
  margin: auto 0;

  @media ${device.MobileL} {
    display: block;
    position: relative;
    bottom: -10%;
  }

`;

export const MenuContainer = styled.div`
  /* toggle display based on being larger than an ipadPro */
  @media ${device.MobileL} {
    display: none;
  }
`;

export const Image = styled.img`
  height: 15px;
  margin-left: 4px;
  position: absolute;
  bottom: 4px;
`;

export const PubLink = styled.a`
  font-family: Poppins;
  font-size: 15px;
  padding: 0 20px;
  color: #201F1F;
  text-decoration: none;


  @media ${device.ipadPro} {
    left: 8%;
    top: -10%;
    font-size: 12px;
  }

  @media ${device.tablet} {
    left: 8%;
    top: 10%;
    padding-bottom: 0px;
  }

  @media ${device.mobileL} {
    display: block;
    padding-bottom: 4px;
  }


`;
